import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CognitoLambdaErrorType } from "@amzn/afxtaco-types";

export interface AuthState {
  signedIn: boolean | null;
  cognitoError: {
    error: string;
    errorType: CognitoLambdaErrorType | null;
    errorDescription?: string;
  } | null;
}

const initialState: AuthState = {
  signedIn: null,
  cognitoError: null,
};

const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    setSignedIn(state, action: PayloadAction<boolean>) {
      const { payload } = action;
      return {
        ...state,
        signedIn: payload,
        // Clear cognito error when successfully signed in
        cognitoError: payload ? null : state.cognitoError,
      };
    },
    setCognitoError(state, action: PayloadAction<AuthState["cognitoError"]>) {
      const { payload } = action;
      return { ...state, cognitoError: payload };
    },
    clearCognitoError(state) {
      return { ...state, cognitoError: null };
    },
  },
});

export const { setSignedIn, setCognitoError, clearCognitoError } =
  AuthSlice.actions;

export default AuthSlice.reducer;
